import { dining_white, private_function } from '../../assets/base64';
import { IS_WEB } from '../../constants/platform';
import { addBase64Prefix } from '../../services/addBase64Prefix';
import { NavigationService } from '../../services/navigation';

export const DINNING_TABS = [
  {
    icon: IS_WEB
      ? addBase64Prefix(dining_white)
      : require('../../assets/dining_white.png'),
    title: 'Dining Reservation',
    onPress: () => {
      NavigationService.push('GrillRoom');
    },
  },
  {
    icon: IS_WEB
      ? addBase64Prefix(private_function)
      : require('../../assets/private-function.png'),
    title: 'Book a Private\nFunction',
    onPress: () => {
      NavigationService.push('PrivateFunction');
    },
  },
  {
    icon: require('../../assets/dining-promotions.png'),
    title: 'Dining Promotions',
    onPress: () => {
      NavigationService.push('DinningPromotion');
    },
  },
  {
    icon: require('../../assets/dining-menus.png'),
    title: 'Dining Menus',
    onPress: () => {
      NavigationService.push('DinningMenu');
    },
  },
];
